import type { AppModule } from '@/app/module-registry';
import { registerHomeSections } from './sections';

/**
 * O modulo `home` nao declara rotas: ele registra os TIPOS de secao que o
 * painel pode usar na home e nas paginas do CMS.
 */
export const homeModule: AppModule = {
  key: 'home',
  order: 0,
  setup: registerHomeSections,
};
